import React from 'react'
import { injectState } from 'freactal'
import app from '../../../../feathers'
import { hasElement, sectionDisplayIndex } from '../../../../lib'
import { Checkbox } from 'react-mdl'
import styled from 'styled-components'

const LabelTd = styled.td`
  text-align: center;
  margin: 5px;
  font-weight: bold;
  text-decoration: underline;
`

const units = app.service('units')
class LearnerGuideContent extends React.Component {
  state = {
    learnerGuideMapping: [],
  }

  componentDidMount() {
    this.initialMapping()
  }

  componentWillReceiveProps() {
    this.initialMapping()
  }

  initialMapping = () => {
    const learnerGuideMapping = this.props.state.unit.sections.map(
      (section, i) => {
        const learnerGuideMapping = []
        section.subsections.forEach(({ name, mapping, subsections }, j) => {
          learnerGuideMapping.push({ sectionIndex: [i, j], name, mapping })
          subsections.forEach(({ name, mapping, subsections }, k) => {
            learnerGuideMapping.push({ sectionIndex: [i, j, k], name, mapping })
            subsections.forEach(({ name, mapping }, l) => {
              learnerGuideMapping.push({
                sectionIndex: [i, j, k, l],
                name,
                mapping,
              })
            })
          })
        })
        return learnerGuideMapping
      },
    )
    this.setState({ learnerGuideMapping })
  }

  handleChangeSectionMapping = async (e, index) => {
    const { _id } = this.props.state.unit
    const { unitElement } = this.props
    const isChecked = e.target.checked
    const op = isChecked ? '$push' : '$pull'
    await units.patch(_id, {
      [op]: {
        [`sections.${index.join('.subsections.')}.mapping`]: unitElement,
      },
    })
  }

  render() {
    const { learnerGuideMapping } = this.state
    const { unitElement } = this.props
    return (
      <tbody>
        {learnerGuideMapping.map((section, i) => [
          <tr>
            <LabelTd colSpan={3}>
              Section {i + 1}
            </LabelTd>
          </tr>,
          ...section.map(({ sectionIndex, name, mapping }, j) =>
            <tr key={`${i}${j}`}>
              <td>
                <Checkbox
                  onChange={e =>
                    this.handleChangeSectionMapping(e, sectionIndex)}
                  checked={hasElement(unitElement, mapping)}
                />
              </td>
              <td>
                {sectionDisplayIndex(sectionIndex)}
              </td>
              <td>
                {name}
              </td>
            </tr>,
          ),
        ])}
      </tbody>
    )
  }
}

export default injectState(LearnerGuideContent)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/MappingModal/LearnerGuideContent.js